import React, { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { ArrowLeft } from 'lucide-react'
import EmailDesigner from './EmailEditor'

interface EmailContentModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onBack: () => void
  onPreview: (content: EmailContent) => void
  testName: string
  initialContent?: EmailContent
  onSendTestEmail?: (p: { subject: string; html: string }) => Promise<void>
}

export interface EmailContent {
  subject: string
  content: string
  html?: string
  designJson?: any
  body?: string
}

const EmailContentModal: React.FC<EmailContentModalProps> = ({
  open,
  onOpenChange,
  onBack,
  onPreview,
  testName,
  initialContent,
  onSendTestEmail,
}) => {
  const [subject, setSubject] = useState(
    initialContent?.subject || `Sınav Davetiyesi - ${testName}`
  )

  const fallbackText =
    initialContent?.content ||
    initialContent?.body ||
    `Sayın {EMPLOYEE_NAME},

Size {TEST_NAME} sınavı atanmıştır. Sınav, NovaForge platformu üzerinden çevrim içi uygulanacaktır.

Giriş Linki:
{LOGIN_LINK}

Sınav Detayları:
• Sınav Adı: {TEST_NAME}
• Erişim Kodu: {ACCESS_CODE}
• Başlangıç Tarihi: {START_DATE}
• Son Giriş Tarihi: {DUE_DATE}
• Sınav Süresi: {TIME_LIMIT}

Başarılar dileriz.
`

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Email Tasarla</DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          <EmailDesigner
            initialSubject={subject}
            initialDesignJson={initialContent?.designJson}
            onCancel={onBack}
            onSave={({ subject: s, html, designJson }) => {
              onPreview({
                subject: s,
                content: fallbackText,
                body: fallbackText,
                html,
                designJson,
              })
            }}
          />

          <div className="flex justify-between pt-4">
            <Button variant="outline" onClick={onBack} className="flex items-center gap-2">
              <ArrowLeft className="h-4 w-4" />
              Geri
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default EmailContentModal
